import MaterialInputBase, { InputBaseProps } from '@mui/material/InputBase';

export function InputBase(props: InputBaseProps) {
    return <MaterialInputBase data-testid={'InputBase-container'} {...props} />;
}

export default InputBase;
